import axios from 'axios';
import { ENV } from '@/config/env';

const http = axios.create({
    baseURL: ENV.VUE_APP_API_BASE_URL,
    headers: { 'Content-Type': 'application/json' }
});
const http_file = axios.create({
    baseURL: ENV.VUE_APP_API_BASE_URL,
    headers: { 'Content-Type': 'multipart/form-data' }
});

// Logged user token, or the application token while there is no session
const authInterceptor = config => {
    const token = localStorage.getItem("user_session") || ENV.VUE_APP_AUTH_TOKEN;
    if (token) {
        config.headers['Authorization'] = `Token ${token}`;
        config.headers['X-CSRFToken'] = token;
    }
    return config;
};

http.interceptors.request.use(authInterceptor, error => Promise.reject(error));
http_file.interceptors.request.use(authInterceptor, error => Promise.reject(error));

export { http, http_file }
